import React from 'react'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

const Copyright = (props, ref) => {
    return (
        <Box mt={8} mb={4}>
            <Typography variant='body2' color='textSecondary' align='center'>
                &copy;{new Date().getFullYear()}&nbsp;
                <Link color='inherit' href='https://hempsteadny.gov' target='_blank'>
                    Town of Hempstead
                </Link>
            </Typography>
        </Box>
    )
}

export default Copyright
